/* eslint-disable */
import { cn } from "../../common/helpers/formatters";

interface StatusIndicatorProps {
  status: "pending" | "success";
  subtitle?: string;
  title: string;
}

const StatusIndicator = ({ status, subtitle, title }: StatusIndicatorProps) => {
  return (
    <div className={cn("status-indicator", `status-${status}`)}>
      <div className="status-indicator-glyph" />
      <div className="flex flex-col justify-center">
        <span className="status-indicator-title">{title}</span>
        {subtitle && <span className="status-indicator-subtitle">{subtitle}</span>}
      </div>
    </div>
  );
};

export default StatusIndicator;
